import { common } from "./environment.common";

export const environment = {
  production: true,
  apiProtocol: "https://",
  apiDomain: "waste-info.com.au",
  voucherApi: "https://waste-voucher-api.herokuapp.com/api",
  ...common,
};
